import {FormGroup} from '@angular/forms';

export function DateMoreThan(thanControlName: string) {
  return (control: FormGroup) => {
    if (!control.parent) return null;

    const formGroup = control.parent as FormGroup;
    const thanControl = formGroup.controls[thanControlName];

    if (!thanControl || !control.value || thanControl.value) return null;

    const [day, month, year] = typeof control.value === 'object' ? control.value.toString().split('/') : control.value.split('/');
    const [day2, month2, year2] = typeof thanControl.value === 'object' ? thanControl.value.toString().split('/') : thanControl.value.split('/');
    return new Date(year2, month2 - 1, day2).getTime() > new Date(year, month - 1, day).getTime() ?
      {mustBeMoreThan: true} : null;
  };
}
